import Vue from 'vue';
import axios from 'axios';

// Plugins
import App from './App.vue';
import Chartist from 'chartist';
import VueAxios from 'vue-axios';
import DashboardPlugin from './material-dashboard';
import VueMeta from 'vue-meta';
import IsDemo from './isDemo';
import NotifyMixin from '@/mixins/notify-mixin';
import vSelect from 'vue-select';
import ClickableLink from '@/components/ClickableLink.vue';

import Chip from '@/components/Chip.vue';

Vue.component('chip', Chip);

Vue.component('v-select', vSelect);

Vue.mixin(NotifyMixin);

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueAxios, axios);
Vue.use(VueMeta, { keyName: 'head' });

// router & store setup
import router from './router';
import store from './store';
import ClickOutside from 'vue-click-outside';
Vue.directive('click-outside', ClickOutside);
Vue.component('clickable-link', ClickableLink);

// global library setup
Vue.prototype.$Chartist = Chartist;

/* eslint-disable no-new */
const app = new Vue({
    router: router,
    store: store,
    el: '#app',
    async created() {
        await this.$store.dispatch('auth/initializeAuth');
    },
    render: h => h(App)
});

store.$app = app;